import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';
import React, {  } from 'react';

import {
  Box, Dialog, Fade, Slide} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { TransitionProps } from '@material-ui/core/transitions';

import { closeOverlayAndReset, updateCurrentScreen } from '../redux/UIOverlayPersonalSizeRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { ClothingType, FitType, getBodyCardFitFamily, getFitFamilyFromKey2 } from 'common-ts/dist/models/UserMeasurements';
import ProductOnUser, { ProductSizeAvailabilityObject } from 'common-ts/dist/models/Product';


import { FlowComponentMasterPersonalSize } from './OverlayViewPersonalSizeDetailBlocks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContainer: {
      zIndex: ((theme.zIndex.modal + 1) + " !important") as any,
    },
    dialogContentContainer: {
      height: '100%',
    },
  }),
);

const UpwardTransition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} timeout={170} />;
});

export function getSortKey(productDetail: ProductOnUser, productSizeAvailability: ProductSizeAvailabilityObject | undefined) {
  const valueKey = (productDetail.isSoldOut || productDetail.isComingAgainSoon || (productSizeAvailability?.numberOfItemsRemaining ?? 0) === 0 ? "B" : "A") + (productDetail.productBackendVersion === 'v4.0' ? "A" : "B") + (productDetail.productId);
  return valueKey;
}

// 2024 Version
// export const itemCategoriesMainText = ["Kaos", "Kaos", "Polo"];
// export const itemCategoriesMainText2 = ["", "", ""];
// export const itemCategoriesSubtext = ["Slim Fit", "Regular Fit", ""];
// export const itemCategoriesClothingType = [ClothingType.Kaos, ClothingType.Kaos, ClothingType.PoloShirt];
// export const itemCategoriesFitType = [FitType.SlimFit, FitType.RegularFit, FitType.RegularFit];

// April 14, 2025 Version
export const itemCategoriesMainText = ["Kaos", "Polo Shirt", "Kemeja", "Kemeja"];
export const itemCategoriesMainText2 = ["", "", "", ""];
export const itemCategoriesSubtext = ["", "", "Lengan Pendek", "Lengan Panjang"];
export const itemCategoriesClothingType = [ClothingType.Kaos, ClothingType.PoloShirt, ClothingType.KemejaPendek, ClothingType.KemejaPanjang];
export const itemCategoriesFitType = [FitType.SlimFit, FitType.RegularFit, FitType.RegularFit, FitType.RegularFit];

export function reorderItemCategories(clothingType: ClothingType, fitType: FitType) {

  const resItemCategoriesMainText = [];
  const resItemCategoriesMainText2 = [];
  const resItemCategoriesSubtext = [];
  const resItemCategoriesClothingType = [];
  const resItemCategoriesFitType = [];

  let foundIndex = -1;
  for (let i = 0; i < itemCategoriesClothingType.length; i++) {
    if (itemCategoriesClothingType[i] === clothingType && itemCategoriesFitType[i] === fitType) {
      foundIndex = i;
      resItemCategoriesMainText.push(itemCategoriesMainText[i]);
      resItemCategoriesMainText2.push(itemCategoriesMainText2[i]);
      resItemCategoriesSubtext.push(itemCategoriesSubtext[i]);
      resItemCategoriesClothingType.push(itemCategoriesClothingType[i]);
      resItemCategoriesFitType.push(itemCategoriesFitType[i]);
      break;
    } 
  }

  for (let i = 0; i < itemCategoriesClothingType.length; i++) {
    if (i === foundIndex) {
      continue;
    }
    resItemCategoriesMainText.push(itemCategoriesMainText[i]);
    resItemCategoriesMainText2.push(itemCategoriesMainText2[i]);
    resItemCategoriesSubtext.push(itemCategoriesSubtext[i]);
    resItemCategoriesClothingType.push(itemCategoriesClothingType[i]);
    resItemCategoriesFitType.push(itemCategoriesFitType[i]);
  }

  return {
    itemCategoriesMainText: resItemCategoriesMainText,
    itemCategoriesMainText2: resItemCategoriesMainText2,
    itemCategoriesSubtext: resItemCategoriesSubtext,
    itemCategoriesClothingType: resItemCategoriesClothingType,
    itemCategoriesFitType: resItemCategoriesFitType,
  }
}

export default function OverlayViewPersonalSize() {
  const overlayView = useAppSelector(state => state.overlayPersonalSize);
  const userAccount = useAppSelector(state => state.account);
  const firstName = useAppSelector(state => state.account.name?.split(' ')?.[0]);

  const [currentFlowData, setCurrentFlowData] = React.useState<any>({});
  const [childrenVisible, setChildrenVisible] = React.useState<boolean>(true);

  const dispatch = useAppDispatch();
  const classes = useStyles();

  const userBodyMeasurementsDictionary = useAppSelector(state => state.userMeasurementsList.userBodyMeasurementsDictionary);
  let userBodyMeasurementCreationDateTimeList: string[] = Object.keys(userBodyMeasurementsDictionary).sort();

  // FIT CARD SYSTEM: this overlay is opened from a key2 context (segment click sets
  // key2CategoryResultShown first). View/edit the latest card WITHIN that key2's fit
  // family — otherwise a newer card from the other family would be shown instead of
  // the card the customer clicked.
  if (overlayView.key2CategoryResultShown) {
    const fitFamily = getFitFamilyFromKey2(overlayView.key2CategoryResultShown);
    userBodyMeasurementCreationDateTimeList = userBodyMeasurementCreationDateTimeList.filter((creationDateTime) =>
      getBodyCardFitFamily(userBodyMeasurementsDictionary?.[creationDateTime]?.[0]) === fitFamily);
  }

  const currentViewedUkuranBadan = userBodyMeasurementCreationDateTimeList?.length ?
    userBodyMeasurementsDictionary?.[userBodyMeasurementCreationDateTimeList[userBodyMeasurementCreationDateTimeList.length - 1]]?.[0] : undefined;

  function closeFunction() {
    dispatch(closeOverlayAndReset());
  }

  function delayedDispatch(currentScreen: string) {
    setChildrenVisible(false);
    setTimeout(() => {
      dispatch(updateCurrentScreen(currentScreen));
      setChildrenVisible(true);
    }, 1000)
  }

  if (!currentViewedUkuranBadan?.creationDateTime) {
    console.log('Not signed in or haven\'t bought an item');
    dispatch(closeOverlayAndReset());
    return null;
  }

  let content: JSX.Element = 
  FlowComponentMasterPersonalSize({
  }, {
    nama: firstName,
    currentScreen: overlayView.personalSizeScreen,
    key2CategoryResultShown: overlayView.key2CategoryResultShown,
    currentUserBodyMeasurement: currentViewedUkuranBadan,
    currentFlowData: currentFlowData,
  }, {
    delayedDispatch: delayedDispatch,
    setCurrentFlowData: setCurrentFlowData
  });

  return (
    <Dialog
    fullScreen
    maxWidth="lg"
    open={overlayView.status === UIOverlayViewStatus.On}
    TransitionComponent={UpwardTransition}
    onClose={closeFunction}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
    className={classes.dialogContainer}>
      <Box className={classes.dialogContentContainer}>
        <Fade in={overlayView.status === UIOverlayViewStatus.On && childrenVisible} timeout={400}>
          {content}
        </Fade>
      </Box>
    </Dialog>
  );
}